import React from 'react';
import { Modal, ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader } from '@fiverr-private/overlay';
import { Typography } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { Center } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import pathfinder from '@fiverr-private/pathfinder';
import sentMessageVisual from './sent-message.svg';

interface MessageSentModalProps {
    sellerName: string;
    isOpen: boolean;
    onClose: () => void;
}

export const MessageSentModal = ({ sellerName, isOpen, onClose }: MessageSentModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent size="sm">
            <ModalHeader>
                <Center>
                    <Image width="208px" height="183px" src={sentMessageVisual} alt="Sent message visual" />
                    Message sent!
                </Center>
                <ModalCloseBtn />
            </ModalHeader>
            <ModalBody>
                <Center>
                    <Typography>{`${sellerName} usually responds within 1 hour.`}</Typography>
                    <Typography>An email will be sent once they reply.</Typography>
                </Center>
            </ModalBody>
            <ModalFooter>
                <Center width="100%" direction="column" alignSelf="center" gap="2" marginTop="8">
                    <Button fullWidth onClick={onClose}>
                        Got it
                    </Button>
                    {sellerName && (
                        <Button
                            fullWidth
                            variant="outline"
                            href={pathfinder(
                                'inbox_conversation_page',
                                { username: sellerName },
                                { query: { source: 'vibe_coding' } }
                            )}
                            target="_blank"
                        >
                            View message
                        </Button>
                    )}
                </Center>
            </ModalFooter>
        </ModalContent>
    </Modal>
);
